// extracted by mini-css-extract-plugin
export default {"wrapper":"informations_wrapper__d9B7X","image":"informations_image__nnfcz","inside":"informations_inside__Ht9Mk"};